import React from 'react';

export default function Hero() {
  return (
    <div className="w-11/12 mx-auto 2xl:max-w-[1200px] pb-[35px] pt-[204px]">
      <ul className="inline-flex items-center">
        <li>
        <div className=' bg-green w-[100px] h-[1px] '  ></div>
        </li>
        <li className="ml-[22px]">
          <h2 className="text-green text-4xl f-f-m">Contact Us</h2>
        </li>
      </ul>
    </div>
  );
}